import { createContext } from 'react';

export const TooltipContainerContext = createContext<string | undefined>(undefined);
